(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ql-quick-add"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__qlQuickAddBound) return;
    window.__qlQuickAddBound = true;

    function positionPanel(panel) {
      panel.style.transform = '';
      var margin = 10;
      var rect = panel.getBoundingClientRect();
      var shift = 0;
      if (rect.left < margin) {
        shift = margin - rect.left;
      } else if (rect.right > window.innerWidth - margin) {
        shift = (window.innerWidth - margin) - rect.right;
      }
      if (shift !== 0) {
        panel.style.transform = 'translateX(' + shift + 'px)';
      }
    }

    function selectPack(root, pack) {
      var panel = root.querySelector('.ql-qa-panel');
      if (!panel) return;

      panel.querySelectorAll('.ql-qa-pack-btn').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-pack') === pack ? 'true' : 'false');
      });
      panel.querySelectorAll('[data-pack-price]').forEach(function (span) {
        span.hidden = span.getAttribute('data-pack-price') !== pack;
      });
      panel.querySelectorAll('.ql-qa-form').forEach(function (form) {
        form.hidden = form.getAttribute('data-pack') !== pack;
      });

      if (!panel.hidden) positionPanel(panel);
    }

    document.addEventListener('click', function (e) {
      var packBtn = e.target.closest('.ql-qa-pack-btn');
      if (packBtn) {
        var packRoot = packBtn.closest('[data-ql-qa-root]');
        if (packRoot) selectPack(packRoot, packBtn.getAttribute('data-pack'));
        return;
      }

      var toggle = e.target.closest('.ql-qa-toggle');
      if (toggle) {
        var root = toggle.closest('[data-ql-qa-root]');
        var panel = root.querySelector('.ql-qa-panel');
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';

        document.querySelectorAll('.ql-qa-toggle[aria-expanded="true"]').forEach(function (t) {
          if (t !== toggle) {
            t.setAttribute('aria-expanded', 'false');
            var p = t.closest('[data-ql-qa-root]').querySelector('.ql-qa-panel');
            if (p) {
              p.hidden = true;
              p.style.transform = '';
            }
          }
        });

        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (panel) {
          panel.hidden = isOpen;
          if (!isOpen) positionPanel(panel);
        }
        return;
      }

      var sizeBtn = e.target.closest('.ql-qa-size');
      if (sizeBtn && !sizeBtn.disabled) {
        var formComponent = sizeBtn.closest('product-form-component');
        var panelEl = sizeBtn.closest('.ql-qa-panel');
        var input = formComponent ? formComponent.querySelector('[data-ql-qa-variant-input]') : null;
        var form = formComponent ? formComponent.querySelector('form') : null;
        if (input && form) {
          input.value = sizeBtn.getAttribute('data-variant-id');
          sizeBtn.setAttribute('data-ql-qa-added', 'true');
          form.requestSubmit();
          setTimeout(function () {
            sizeBtn.removeAttribute('data-ql-qa-added');
            if (panelEl) {
              panelEl.hidden = true;
              panelEl.style.transform = '';
              var t = panelEl.closest('[data-ql-qa-root]').querySelector('.ql-qa-toggle');
              if (t) t.setAttribute('aria-expanded', 'false');
            }
          }, 700);
        }
        return;
      }

      var openPanel = document.querySelector('.ql-qa-panel:not([hidden])');
      if (openPanel && !e.target.closest('[data-ql-qa-root]')) {
        openPanel.hidden = true;
        openPanel.style.transform = '';
        var openToggle = openPanel.closest('[data-ql-qa-root]').querySelector('.ql-qa-toggle');
        if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
